import { render } from "./TournamentCard.vue?vue&type=template&id=0b51d2cc&scoped=true&ts=true"
import script from "./TournamentCard.vue?vue&type=script&lang=ts"
export * from "./TournamentCard.vue?vue&type=script&lang=ts"

import "./TournamentCard.vue?vue&type=style&index=0&id=0b51d2cc&lang=scss&scoped=true"

import exportComponent from "/opt/booza-vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b51d2cc"]])

export default __exports__